import {
  FETCH_ARTICLES_SUCCESS,
  UPDATE_ARTICLE_EVENT_SUCCESS,
  RESET_ARTICLES,
} from 'config/constants';

export default (state = [], action) => {
  const { type, articles } = action;
  switch (type) {
    case FETCH_ARTICLES_SUCCESS:
      let list = [...new Set([...state, ...articles])];
      return list.filter(
        (elem, index, self) =>
          self.findIndex(t => {
            return t.id === elem.id;
          }) === index
      );
    case RESET_ARTICLES:
      return [];
    case UPDATE_ARTICLE_EVENT_SUCCESS:
      const { data, id } = articles;
      let novoState = state.map(article => {
        if (article.id !== id) return article;
        article.dislike_count = data.article.dislike_count;
        article.like_count = data.article.like_count;
        return article;
      });
      return novoState;
    default:
      return state;
  }
};
